import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Row, Col } from 'react-bootstrap';
import Select from '../../../../modules/react/components/stateful/Select';
import styling from '../EditCouponModal/EditCouponModal.scss';

export default class CouponStyleTab extends React.Component {
  static propTypes = {
    colors: PropTypes.shape({
      primary: PropTypes.string.isRequired,
      secondary: PropTypes.string.isRequired,
    }).isRequired,
    color: PropTypes.string,
    handleColorChange: PropTypes.func,
    handleStyleChange: PropTypes.func,
    renderCouponStyle: PropTypes.func,
    showColorField: PropTypes.bool,
    style: PropTypes.string,
    currencySymbol: PropTypes.string,
  };

  renderColor(marginTop) {
    const { colors: { primary, secondary } } = this.props;
    return (option) => {
      if (option.value === primary || option.value === secondary) {
        return (
          <span>
            <div
              style={{ backgroundColor: option.value, marginTop }}
              className={styling.colorBlock}
            />
            {option.label}
          </span>
        );
      }
      return <span style={{ marginLeft: '15px' }}>{option.label}</span>;
    };
  }

  renderStyleOption(option) {
    const {
      color, handleStyleChange, renderCouponStyle, style, currencySymbol, colors: { primary },
    } = this.props;
    const className = cx(
      styling.selectedStyle,
      {
        [styling.nonselectedStyle]: style !== option,
        [styling.specialOfferContainer]: option === 'special-offer',
      },
    );

    return (
      <div
        onClick={() => handleStyleChange(option)}
        className={className}
      >
        <div className={option === 'special-offer' ? styling.specialOffer : ''}>
          {renderCouponStyle({ style: option, color, currencySymbol, primary })}
        </div>
        <div className={`${styling.svgName} ${option === 'special-offer' ? styling.specialsvgName : ''}`}>
          {option.split('-').map(i => i[0].toUpperCase() + i.substring(1)).join(' ')}
        </div>
      </div>
    );
  }

  render() {
    const {
      color, colors: { primary, secondary }, handleColorChange, showColorField,
    } = this.props;
    const options = [
      { value: primary, label: 'primary' },
      { value: secondary, label: 'secondary' },
      { value: 'custom', label: 'custom' },
    ];
    return (
      <div className={styling.image}>
        <div className={styling.descriptionStyle}>
          Select the style of coupon you want.
        </div>
        {this.renderStyleOption('special-offer')}
        {this.renderStyleOption('gift-tag')}
        {this.renderStyleOption('starburst')}
        {this.renderStyleOption('hexagon')}
        {this.renderStyleOption('shield')}
        <div>
          <div className={styling.descriptionStyle}>
            Coupon Color
          </div>
          <div>
            <input
              name="color"
              type="color"
              value={color}
              className={styling.colorSelect}
              onChange={({ target }) => handleColorChange(target)}
            />
          </div>
          <Row>
            <Col xs={3}>
              <Select
                autoBlur
                className={styling.selectColorOptions}
                clearable={false}
                instanceId="color-selector"
                onChange={handleColorChange}
                optionRenderer={this.renderColor('3px')}
                valueRenderer={this.renderColor('10px')}
                options={options}
                value={color === primary || color === secondary ? color : 'custom'}
                searchable={false}
              />
            </Col>
            {
              showColorField ?
                <Col xs={3}>
                  <Col xs={1} className={styling.hash}>#</Col>
                  <Col xs={2}>
                    <input
                      value={color.substr(1)}
                      name="color"
                      className={styling.hexInputField}
                      onChange={({ target }) => handleColorChange({ value: `#${target.value}` })}
                    />
                  </Col>
                </Col>
                : null
            }
          </Row>
        </div>
      </div>
    );
  }
}
